export default __webpack_public_path__ + "static/media/slide1.8870e1e6.webp";